import technicalFacets from './technicalFacets';

export default (unselectedGroups, groups, baseFacets, activeFilters = []) => {
  const nonTechnicalBaseFacets = (baseFacets || []).filter(
    (group) => !technicalFacets.includes(group.associatedFieldName),
  );
  const allGroups = nonTechnicalBaseFacets.map((baseFacet) => {
    const updatedFacet =
      (unselectedGroups || []).find((item) => item?.name === baseFacet.name) ||
      (groups || []).find((item) => item?.name === baseFacet.name);

    let hasEnabledElements = false;
    let hidden = false;
    const elements = (baseFacet.elements || baseFacet.values).map((baseElement) => {
      const { associatedFieldName } = baseFacet;

      const element = {
        ...baseElement,
        disabled: true,
        selected: false,
        selectedBool: false,
        recordCount: null,
        totalHits: null,
        associatedFieldName,
      };

      const activeFilter = activeFilters.find((filter) => {
        const filterName = filter.fakeValue || filter.name;
        return (
          filter.associatedFieldName === associatedFieldName &&
          (filterName === baseElement.name ||
            filterName === baseElement.text ||
            filter.selectedMaxValue)
        );
      });
      const updatedElement = updatedFacet?.elements.find(
        (facetElement) =>
          (facetElement.text && facetElement.text === baseElement.text) ||
          facetElement.absoluteMaxValue,
      );
      if (updatedElement) {
        const isSingleValueRange =
          !updatedElement.selectedBool &&
          updatedElement.absoluteMaxValue !== null &&
          (updatedElement.absoluteMaxValue === updatedElement.absoluteMinValue || // single value range (eg. minValue = 5 && maxValue = 5
            ((!Number.isInteger(updatedElement.absoluteMinValue) ||
              !Number.isInteger(updatedElement.absoluteMaxValue)) &&
              Math.ceil(updatedElement.absoluteMaxValue) <=
                Math.floor(updatedElement.absoluteMinValue) + 1)); // fraction facets when min and max are within 1, eg. min: 2.3 max: 2.8 -> hidden

        if (isSingleValueRange) {
          hidden = true;
        }

        if (baseFacet.type === 'FLOAT' || baseFacet.type === 'INTEGER') {
          element.absoluteMaxValue = updatedElement.absoluteMaxValue;
          element.absoluteMinValue = updatedElement.absoluteMinValue;
          element.selectedMaxValue = updatedElement.selectedMaxValue;
          element.selectedMinValue = updatedElement.selectedMinValue;
        }

        element.recordCount = updatedElement.recordCount;
        element.totalHits = updatedElement.totalHits;
        element.disabled = isSingleValueRange;
        hasEnabledElements = hasEnabledElements || !isSingleValueRange;
      }
      if (activeFilter) {
        element.selected = true;
        element.selectedBool = true;
        element.disabled = false;
        hasEnabledElements = true;
        if (baseFacet.type === 'FLOAT' || baseFacet.type === 'INTEGER') {
          const srcElement = updatedElement || baseElement;
          element.absoluteMaxValue = srcElement.absoluteMaxValue;
          element.absoluteMinValue = srcElement.absoluteMinValue;
          element.selectedMaxValue = activeFilter.selectedMaxValue;
          element.selectedMinValue = activeFilter.selectedMinValue;
        }
      }

      return element;
    });

    return {
      ...baseFacet,
      elements,
      disabled: !hasEnabledElements,
      hidden,
    };
  });

  // workaround FF bug
  return allGroups.filter((filter) => !filter.hidden);
};
